import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
	Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MACStandardFeeNote from "./MACStandardFeeNote";

const InvoiceDialog = ({ open, onClose, onCloseInvoice }) => (
	<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
		<DialogTitle variant="h4" align="center" gutterBottom>
			MAC Standard Fee Note
			<Divider style={{ marginBottom: 10 }} />
			<IconButton
				aria-label="close"
				onClick={onClose}
				style={{ position: "absolute", right: 8, top: 8 }}
			>
				<CloseIcon />
			</IconButton>
		</DialogTitle>
		<DialogContent>
			<MACStandardFeeNote onCloseInvoice={onCloseInvoice} />
		</DialogContent>
	</Dialog>
);

export default InvoiceDialog;
